import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { create, reset } from '../../actions/tag/create';
import { VersionLink as Link } from '../VersionLink';
import Form from './Form';

class Create extends Component {
  static propTypes = {
    error: PropTypes.string,
    loading: PropTypes.bool.isRequired,
    created: PropTypes.object,
    create: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired
  };

  componentWillUnmount() {
    this.props.reset();
  }

  render() {
    if (this.props.created)
      return (
        <Redirect
          //to={`edit/${encodeURIComponent(this.props.created['@id'])}`}
          to={'/tags/'}
        />
      );

    return (
      <div className="edit-tag-wrapper">
        <div className={'page-actions-wrapper'}>
          <div className={'page-actions new-tag-actions'}>
            <Link to="." className="btn btn-primary btn-yellow">
              Back to list
            </Link>
          </div>
        </div>
        <div
          className={
            'edit-tag-container col-lg-4 col-md-6 col-sm-8 offset-lg-4 offset-md-3 offset-sm-2'
          }
        >
          <h1 className={'text-center'}>New Tag</h1>
          {this.props.loading && (
            <div className="alert alert-info" role="status">
              Loading...
            </div>
          )}
          {this.props.error && (
            <div className="alert alert-danger" role="alert">
              <span className="fa fa-exclamation-triangle" aria-hidden="true" />{' '}
              {this.props.error}
            </div>
          )}

          <Form onSubmit={this.props.create} values={this.props.item} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { created, error, loading } = state.tag.create;
  return { created, error, loading };
};

const mapDispatchToProps = dispatch => ({
  create: values => dispatch(create(values)),
  reset: () => dispatch(reset())
});

export default connect(mapStateToProps, mapDispatchToProps)(Create);
